import { Splide } from "@splidejs/splide";
import { event } from "jquery";

document.addEventListener("DOMContentLoaded", function() {
    // Image silder mobile
    const productSlider = new Splide(".splide-section_product-images-slider", {
        type: "slide",
        arrows: false,
        pagination: false,
        perPage: 1,
        perMove: 1
    });

    let bar = productSlider.root.querySelector(".product-slider__progress-bar");
    // Updates the bar width whenever the carousel moves:
    productSlider.on("mounted move", function() {
        var end = productSlider.Components.Controller.getEnd() + 1;
        var rate = Math.min((productSlider.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + "%";
    });
    productSlider.mount();

    /** ADD TO CART LOGIC */

    function addToCart(event) {
        event.preventDefault();
        const form = event.target;
        const sku = form.querySelector('input[name="sku"]').value;
        const price = form.querySelector('input[name="price"]').value;
        const currency = form.querySelector('input[name="currency"]').value;
        const product_id = form.querySelector('input[name="product_id"]').value;

        if (sku != "null") {
            const addToCartText = document.querySelector(
                "#add-to-cart-button-text"
            );
            addToCartText.innerText = addToCartText.dataset.ok;
            document.querySelector("#add-to-cart").disabled = false;
            window.helpers.addCart(sku, price, currency, product_id);
        } else {
            console.log("Please select a size");
        }
    }

    const product_forms = document.querySelectorAll("#add-to-cart-form");

    product_forms.forEach(form => {
        form.addEventListener("submit", addToCart);
    });

    /** END ADD TO CART LOGIC */

    // scroll listener images thumbs
    window.onscroll = function() {
        var images = document.querySelectorAll(
            ".product__images.desktop-only img"
        );
        // check if the top of the image is visible if true, then add the class visible to the image in the thumbs with the same index
        images.forEach(function(image) {
            var rect = image.getBoundingClientRect();
            if (
                rect.top <= window.innerHeight / 2 &&
                rect.bottom >= window.innerHeight / 2
            ) {
                const target = image.dataset.index;
                const limit = Number(target.replace("index-", ""));
                const images_count = images.length;

                for (let i = 1; i <= limit; i++) {
                    document
                        .getElementById("index-" + i)
                        .classList.add("visible");
                }

                for (let i = 0; i < images_count; i++) {
                    if (i >= limit) {
                        document
                            .getElementById("index-" + (i + 1))
                            .classList.remove("visible");
                    }
                }
            }
        });
    };

    // add event listener onhover color-selector
    document.querySelectorAll(".color-selector").forEach(function(color) {
        color.addEventListener("mouseover", function() {
            const id = color.dataset.id;
            const colorVersion = color.dataset.color;
            const labels = document.querySelectorAll(".product__color span");
            labels.forEach(function(label) {
                label.textContent = colorVersion;
            });
        });

        // on mouseout reset the color
        color.addEventListener("mouseout", function() {
            const labels = document.querySelectorAll(".product__color span");
            labels.forEach(function(label) {
                label.textContent = label.dataset.default;
            });
        });
    });

    // additiona-infos-button event listener
    document
        .querySelectorAll(".additiona-infos-button")
        .forEach(function(button) {
            button.addEventListener("click", function() {
                const target = button.dataset.target;
                document.getElementById(target).classList.add("active");

                const product_name = button.dataset.name;
                const product_id = button.dataset.id;
                let type = button.dataset.type;
                let tabType;

                switch (type) {
                    case "aside-modal-payment":
                        tabType = "tab_payment";
                        break;
                    case "aside-modal-shipping":
                        tabType = "tab_shipping";
                        break;
                    case "aside-modal-return":
                        tabType = "tab_return";
                    default:
                        break;
                }

                // push dataLayer
                dataLayer.push({
                    event: "product_action",
                    item_id: product_id,
                    item_name: product_name,
                    event_detail: tabType
                });
            });
        });

    document.querySelectorAll(".sku-item").forEach(function(sku) {
        sku.addEventListener("click", function() {

            document.querySelectorAll(".sku-item").forEach(function(sku) {
                sku.classList.remove("active");
            });

            sku.classList.add("active");
            // also active other elements with same data-rel
            document.querySelectorAll(".sku-item").forEach(function(clone_sku) {
                if (sku.dataset.rel === clone_sku.dataset.rel) {
                    clone_sku.classList.add("active");
                }
            });
            document
                .querySelectorAll('input[name="sku"]')
                .forEach(function(input) {
                    input.value = sku.dataset.rel;
                });

            document.querySelectorAll("#add-to-cart").forEach(function(button) {
                button.disabled = false;
            });

            document
                .querySelectorAll("#add-to-cart-button-text")
                .forEach(function(button) {
                    button.innerText = button.dataset.ok;
                });
        });
    });

    // Toggle sizes

    function toggleSizeChart(event) {
        document.querySelector(".modal__sizes").classList.add("active");
        const product_name = event.target.dataset.name;
        const product_id = event.target.dataset.id;
        dataLayer.push({
            event: "product_action",
            item_id: product_id,
            item_name: product_name,
            event_detail: "size_guide"
        });
    }

    const sizeChartButtons = document.querySelectorAll(
        ".product-sizes-chart-button"
    );

    sizeChartButtons.forEach(function(button) {
        button.addEventListener("click", toggleSizeChart);
    });
});
